import React from 'react';
import { componentService } from 'js/services/component.service';

export const ScheduledBreaks = React.lazy(() => import(/* webpackChunkName: "scheduled-breaks" */ './ScheduledBreaks'));

componentService.registerPageComponents({ 'scheduled-breaks': ScheduledBreaks });
